import { api } from "apiConnections";
import { AxiosRequestConfig } from "axios";

const requests = {
    update: (data: object, config: AxiosRequestConfig) =>
        api.put(`/modules/AutoAcceptDeliverySlip`, data, config),
};

export default requests;
